import { z } from "zod";

export const sponsorSchema = z.object({
  firstName: z.string().min(2, "First name is required"),
  lastName: z.string().min(2, "Last name is required"),
  email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  address: z.string().min(5, "Address is required"),
  zipCode: z.string().min(2, "Zip code is required"),
  city: z.string().min(2, "City is required"),
  country: z.string().min(2, "Country is required"),
  sponsorshipType: z.string().min(1, "Sponsorship type is required"),
  monthlyAmount: z.string().min(1, "Monthly amount is required"),
  message: z.string().optional(),
});

export type SponsorCreateType = z.infer<typeof sponsorSchema>;
